module.exports = __webpack_public_path__ + "static/DEV6-c9ef5361aa8ee116d767c734b880df43.png";